export default {
  name: "Language",
  en: "English",
  cn: "简体中文",
  tw: "繁体中文",
  vi: "Tiếng Việt",
  th: "ภาษาไทย",
  id: "Indonesia",
  my: "Myanmar",
  jp: "日本語",
  kr: "한국어"
};
